import { PrimitiveAtom, useAtom } from 'jotai'

import { uploadInProgress } from '@/store/documents/DocumentsAtom'
import { chatSettingsAtom } from '@/store/gigiChat/ChatAtom'
import { IConversationSettings } from '@/types/gigiChat/ConversationSettings'

import UploadingTranslateDocuments from './UploadingTranslateDocuments'

const Container = () => {
    const [chatSettings] = useAtom<PrimitiveAtom<IConversationSettings | null>>(chatSettingsAtom)
    const [isUploading] = useAtom<PrimitiveAtom<boolean>>(uploadInProgress)
    return (
        <UploadingTranslateDocuments
            isUploading={isUploading}
            isFullHeight={chatSettings?.processingStrategyTranslation.docs.length === 0}
        />
    )
}

export default Container
